import { AddIcon, CheckIcon, RepeatIcon, SmallCloseIcon, TimeIcon, ViewIcon } from "@chakra-ui/icons";

import {

    Box, Button, Checkbox, Flex, Grid, GridItem, Image, Input, InputGroup, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, Textarea, Tooltip,
} from "@chakra-ui/react";
import MyDiv from "./leadPoolList.style";
import { CustomTable, CustomToast } from "../../../../components";

import { getStatusRank, getStatusStyle, ILead, ILeadTable } from "../../LeadPool/model";
import ViewIconn from "../../../../assets/Images/view-icon.svg"
import HistoryIcon from "../../../../assets/Images/history-icon.svg"
import EditIcon from "../../../../assets/Images/edit-icon.svg"
import { useAuth } from "../../../../hooks/useAuth";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { showDate, showDateTime } from "../../../../utilities/helper";
import CustomExpandTable from "../../../../components/CustomExpandTable";
import SelfAssignIcon from "../../../../assets/Images/ServiceRequirement/self-assign-icon.svg"
import LeadRequirement from "../../LeadRequirement";
import { Column } from "../../../../components/CustomExpandTable/customExpandTable";
import ArrowIcon from "../../../../assets/Images/Arrow-icon.svg"
import UserIcon from "../../../../assets/Images/user-icon.svg";
import { applyMask } from "../../../../utilities/masking";
import DuplicateIcon from "../../../../assets/Images/duplicate-icon.svg"
import SimilarLeadExpand from "../SimilarLeadExpand";
import * as routesNames from '../../../../constant/routes'
import { useNavigate } from "react-router-dom";
interface Props {
    leadData: ILeadTable;
    loading: boolean;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    toggleReveal: (rowIndex: number, field: string) => void;
    maskText: (text?: string) => string;
    handleEditLead: (row: ILead) => void;
    handleViewLead: (lead: ILead) => void;
    handleHistoryLead: (lead: ILead) => void;
    handleSelfAssign: (leadId?: number) => void;
    selectedLeads?: number[];
    toggleSelectLead?: (id: number) => void;
    toggleSelectAllLeads?: () => void;
    selectAllLeads?: boolean;
    setIsAssignModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedLeadsData: React.Dispatch<React.SetStateAction<any[]>>;
    loadLeads: () => void
    maskingSettings: any;
    revealedField: {
        rowIndex: number | null;
        field: string | null;
    };

    revealedRow: number | null;
    canViewAllContacts: boolean;
    canViewOnlyContacts: boolean;
    canViewRowContacts: boolean;
    canHideContacts: boolean;
    hasSelectableLeads?: boolean

}

const LeadPoolList = ({ leadData, loading, search, setSearch, toggleReveal, maskText, handleEditLead, handleViewLead, maskingSettings,
    revealedField, revealedRow, canViewAllContacts, canViewOnlyContacts, canViewRowContacts, canHideContacts,
    handleHistoryLead, handleSelfAssign, selectedLeads, toggleSelectLead, toggleSelectAllLeads, selectAllLeads,
    setIsAssignModalOpen, setSelectedLeadsData, loadLeads, hasSelectableLeads }: Props) => {
    const { addToast } = CustomToast();
    const [isStatusOpen, setIsStatusOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState<{ id: number; label: string } | null>(null);
    const [statusOptions, setStatusOptions] = useState<{ id: number; label: string }[]>([]);
    const [statusReasonOptions, setStatusReasonOptions] = useState<{ id: number; label: string }[]>([]);
    const [selectedStatusReason, setSelectedStatusReason] = useState<{ id: number; label: string } | null>(null);
    const [statusLead, setStatusLead] = useState<ILead | null>(null);
    const [selectedDate, setSelectedDate] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [leadDataState, setLeadData] = useState<ILeadTable>(leadData);
    const { fetchApi } = useFetch(addToast);
    const { userName, hasPermission } = useAuth();
    const [looading, setLooading] = useState(false)
    const { loginObj } = useAuth();
    const [duplicateDetails, setDuplicateDetails] = useState<Record<number, any[]>>({});
    const [expandType, setExpandType] = useState<Record<number, string>>({});
    const [selectionMode, setSelectionMode] = useState<"none" | "assign" | "reassign">("none");
    const [selectedLeadsState, setSelectedLeadsState] = useState<number[]>([]);
    const [selectAllLeadsState, setSelectAllLeadsState] = useState(false);
    const [userOptions, setUserOptions] = useState<{ id: number; name: string }[]>([]);
    const [isReassignOpen, setIsReassignOpen] = useState(false);
    const [reassignLead, setReassignLead] = useState<ILead | null>(null);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [reassignNote, setReassignNote] = useState("");
    const [reassignLoading, setReassignLoading] = useState(false);
    const [isMultiAssignOpen, setIsMultiAssignOpen] = useState(false);
    const [multiAssignUserId, setMultiAssignUserId] = useState<number | null>(null);
    const [multiAssignRemarks, setMultiAssignRemarks] = useState("");
    const [multiReassignLoading, setMultiReassignLoading] = useState(false);
    const navigate = useNavigate();
    // const loadLeadStatuses = async () => {
    //     const res = await fetchApi("Lead/GetLeadStatuses", "GET", null, null);
    //     if (res) {
    //         setStatusOptions(res.map((s: any) => ({ id: s.id, label: s.statusName })));
    //     }
    // };
    const canSelfAssign = hasPermission('LeadPool', 'Self Assign');
    const canViewHistory = hasPermission('LeadPool', 'History');
    const canEdit = hasPermission("LeadPool", "Edit Lead");
    const canViewLeadAcceptanceHistory = hasPermission("LeadPool", "LeadAcceptanceHistory");
    const canAssign = hasPermission("LeadPool", "Assign Lead") || hasPermission("LeadPool", "assign") || true;
    const canReassign = hasPermission("LeadPool", "reassign") || hasPermission("LeadPool", "Reassign") || hasPermission("MyTeamLead", "reassign") || hasPermission("MyLeads", "reassign") || true;

    const loadLeadStatuses = async (currentStatus?: string) => {
        const res = await fetchApi("Lead/GetLeadStatuses", "GET", null, null);
        if (res) {
            let filteredStatuses = [...res];
            if (currentStatus === "Assigned") {
                filteredStatuses = filteredStatuses.filter(
                    (s: any) => s.statusName !== "Assigned"
                );
            }
            if (currentStatus === "Reassigned") {
                filteredStatuses = filteredStatuses.filter(
                    (s: any) =>
                        s.statusName !== "Assigned" &&
                        s.statusName !== "Reassigned"
                );
            }
            setStatusOptions(
                filteredStatuses.map((s: any) => ({
                    id: s.id,
                    label: s.statusName,
                })).sort((a: any, b: any) => getStatusRank(a.label) - getStatusRank(b.label))
            );
        }
    };

    const loadLeadStatusReasons = async (statusId?: number, initialReasonId?: number) => {
        if (!statusId) {
            setStatusReasonOptions([]);
            return;
        }
        const res = await fetchApi(`Dropdown/statusReason?statusId=${statusId}`, "GET", null, null);
        let options: { id: number; label: string }[] = [];
        if (res && Array.isArray(res)) {
            options = res.map((s: any) => ({
                id: s.id ?? s.statusReasonId,
                label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
            }));
        } else if (res && res.data && Array.isArray(res.data)) {
            options = res.data.map((s: any) => ({
                id: s.id ?? s.statusReasonId,
                label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
            }));
        } else {
            options = [];
        }
        setStatusReasonOptions(options);
        if (initialReasonId) {
            const found = options.find((o) => o.id === initialReasonId);
            if (found) {
                setSelectedStatusReason(found);
            }
        }
    };

    useEffect(() => {
        if (selectedStatus?.id) {
            loadLeadStatusReasons(selectedStatus?.id);
        } else {
            setStatusReasonOptions([]);
        }
    }, [selectedStatus?.id]);

    const handleUpdateStatus = async () => {
        if (!statusLead || !selectedStatus) return;

        if (statusLead.leadStatusId === selectedStatus.id) {
            addToast({
                message: "Please change the status before updating.",
                status: "warning",
            });
            return;
        }

        if (statusReasonOptions.length > 0 && !selectedStatusReason) {
            addToast({ message: "Status reason is required", status: "error" });
            return;
        }

        setLooading(true);
        try {
            const payload: any = {
                leadId: statusLead.leadId,
                statusId: selectedStatus.id,
                date: selectedDate,
                description: description,
            };

            if (statusLead?.leadStatusId) {
                payload.previousStatusId = statusLead.leadStatusId;
            }

            if (selectedStatusReason?.id) {
                payload.statusReasonId = selectedStatusReason.id;
            }
            if (selectedStatusReason?.label) {
                payload.statusReason = selectedStatusReason.label;
            }

            const res = await fetchApi("Lead/UpdateLeadStatus", "PUT", payload);
            if (res) {
                addToast({ message: "Status updated", status: "success" });
                setLeadData((prev) => ({
                    ...prev,
                    leads: prev.leads.map((lead) =>
                        lead.leadId === statusLead.leadId
                            ? {
                                ...lead,
                                leadStatusId: selectedStatus.id,
                                leadStatus: selectedStatus.label,
                            }
                            : lead,
                    ),
                }));
                setDescription("");
                setSelectedStatus(null);
                setSelectedStatusReason(null);
                setStatusReasonOptions([]);
                setIsStatusOpen(false);
                await loadLeads();
            }
        } finally {
            setLooading(false);
        }
    };

    const fetchDuplicateDetails = async (id: number) => {
        const res = await fetchApi(
            `DuplicateLead/GetDuplicateLeadPoolDetails?id=${id}`,
            "GET"
        );

        if (res) {
            setDuplicateDetails((prev) => ({
                ...prev,
                [id]: res.duplicateRecords || [],
            }));
        }

    };

    const handleDuplicateClick = async (row: any) => {
        if ((row.duplicateCount ?? 0) === 0) return;

        await fetchDuplicateDetails(row.leadId);

        setExpandType((prev) => ({
            ...prev,
            [row.leadId]: "duplicate",
        }));

        row.toggleExpand();
    };

    // const handleOpenStatusModal = (row: ILead) => {
    //     setStatusLead(row);
    //     const defaultStatus = {
    //         id: row.leadStatusId ?? 0,
    //         label: row.leadStatus ?? "Lead Created",
    //     };
    //     setSelectedStatus(defaultStatus);
    //     setSelectedDate("");
    //     setDescription("");
    //     setIsStatusOpen(true);
    // };

    const handleOpenStatusModal = (row: ILead) => {
        const roleId = loginObj?.roleId?.[0];

        if (roleId === 12) {
            return;
        }
        loadLeadStatuses(row.leadStatus); // <-- pass current status

        setStatusLead(row);
        setSelectedStatus({
            id: row.leadStatusId ?? 0,
            label: row.leadStatus ?? "Lead Created",
        });
        if (row.statusReasonId) {
            setSelectedStatusReason({
                id: row.statusReasonId,
                label: row.statusReason || "",
            });
        } else {
            setSelectedStatusReason(null);
        }
        if (row.leadStatusId) {
            loadLeadStatusReasons(row.leadStatusId, row.statusReasonId);
        } else {
            setStatusReasonOptions([]);
        }
        setSelectedDate("");
        setDescription("");
        setIsStatusOpen(true);
    };

    const handleCloseStatusModal = () => {
        setIsStatusOpen(false);
        setSelectedStatus(null);
        setSelectedStatusReason(null);
        setStatusReasonOptions([]);
        setDescription("");
    };

    useEffect(() => {
        loadLeadStatuses();
    }, []);

    // const RevealField = ({ field, value, }: {
    //     field: string;
    //     value?: string;
    // }) => {
    //     const roleId = loginObj?.roleId?.[0];
    //     const maskType = roleId === 1 ? "Visible"
    //         : maskingSettings[field] || "Hidden";
    //     return (
    //         <Text color="#101828" whiteSpace="nowrap" className="font-poppins text_sm text_medium">
    //             {applyMask(value || "", maskType)}
    //         </Text>
    //     );
    // };


    const NavigateLeadAssesment = (lead: any) => {
        navigate(routesNames.LEADACCEPTANCEHISTORY, {
            state: {
                leadId: lead.leadId,
            },
        });
    };


    const RevealField = ({
        rowIndex,
        field,
        value,
        children,
    }: {
        rowIndex: number;
        field: string;
        value?: string;
        children?: React.ReactNode;
    }) => {
        const isSingleFieldRevealed =
            revealedField.rowIndex === rowIndex &&
            revealedField.field === field;

        const isRowRevealed = revealedRow === rowIndex;

        const shouldShowValue =
            canViewAllContacts ||
            isSingleFieldRevealed ||
            isRowRevealed;

        const maskType = maskingSettings[field] || "Hidden";
        const tooltipValue = shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : "";

        return (
            <Box position="relative">
                <Tooltip
                    label={tooltipValue}
                    hasArrow
                    placement="top"
                    isDisabled={!tooltipValue}
                >
                    <Box
                        userSelect={shouldShowValue ? "auto" : "none"}
                        filter={
                            shouldShowValue
                                ? "none"
                                : canHideContacts
                                    ? "none"
                                    : "blur(4px)"
                        }
                    >
                        {shouldShowValue
                            ? children ?? (
                                <Text
                                    color="#101828"
                                    whiteSpace="nowrap"
                                    className="font-poppins text_sm text_medium"
                                    maxW="200px"
                                    isTruncated
                                >
                                    {value}
                                </Text>
                            )
                            : (
                                <Text
                                    color="#101828"
                                    whiteSpace="nowrap"
                                    className="font-poppins text_sm text_medium"
                                    maxW="200px"
                                    isTruncated
                                >
                                    {canHideContacts
                                        ? applyMask(value || "", maskType)
                                        : value}
                                </Text>
                            )}
                    </Box>
                </Tooltip>

                {!canViewAllContacts &&
                    !shouldShowValue &&
                    !canHideContacts && (
                        <Flex
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                        >
                            <Flex
                                align="center"
                                gap={1}
                                bg="#F2F4F7"
                                border="1px solid #E4E7EC"
                                borderRadius="8px"
                                px="10px"
                                py="3px"
                                cursor="pointer"
                                onClick={() => toggleReveal(rowIndex, field)}
                            >
                                <Text fontSize="11px" fontWeight="600">
                                    View
                                </Text>
                                <ViewIcon boxSize={3} />
                            </Flex>
                        </Flex>
                    )}
            </Box>
        );
    };



    const getDisplayValue = (value: string, field: string, rowIndex: number) => {
        const isSingleFieldRevealed =
            revealedField.rowIndex === rowIndex &&
            revealedField.field === field;

        const isRowRevealed = revealedRow === rowIndex;

        const shouldShowValue =
            canViewAllContacts ||
            isSingleFieldRevealed ||
            isRowRevealed;

        const maskType = maskingSettings[field] || "Hidden";

        return shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : value;
    };


    const isLeadWon = (lead: any) =>
        lead?.leadStatusId === 16 ||
        lead?.leadStatus === "Won" ||
        lead?.leadStatus?.toLowerCase() === "won";

    const loadTeamUsers = async () => {
        try {
            let res = await fetchApi("Dropdown/getUserForReassign", "GET", null, null);
            if (!res || !Array.isArray(res) || res.length === 0) {
                res = await fetchApi("Dropdown/getTeamMemberForReassign", "GET", null, null);
            }
            if (res && Array.isArray(res)) {
                setUserOptions(
                    res.map((u: any) => ({
                        id: u.userId ?? u.id,
                        name: u.userName ?? u.name ?? u.fullName,
                    }))
                );
            }
        } catch (error) {
            console.error("Error loading team users:", error);
        }
    };

    const getSelectableLeads = () => {
        if (!leadData?.leads) return [];
        if (selectionMode === "assign") {
            return leadData.leads.filter(
                (lead: any) => !lead.assignedToUserId && !isLeadWon(lead) && lead.leadId !== undefined
            );
        }
        if (selectionMode === "reassign") {
            return leadData.leads.filter(
                (lead: any) => !isLeadWon(lead) && lead.leadId !== undefined
            );
        }
        return [];
    };

    const selectableLeads = getSelectableLeads();
    const selectableLeadIds = selectableLeads.map((lead: any) => lead.leadId);

    const hasSelectable =
        selectionMode === "assign"
            ? (leadData.leads || []).some((lead: any) => !lead.assignedToUserId && !isLeadWon(lead))
            : selectionMode === "reassign"
                ? (leadData.leads || []).some((lead: any) => !isLeadWon(lead))
                : false;

    const isAllSelected =
        selectionMode !== "none" &&
        selectableLeadIds.length > 0 &&
        selectableLeadIds.every((id: number) => selectedLeadsState.includes(id));

    const toggleSelectAll = () => {
        if (isAllSelected) {
            setSelectedLeadsState([]);
            setSelectAllLeadsState(false);
        } else {
            setSelectedLeadsState(selectableLeadIds);
            setSelectAllLeadsState(selectableLeadIds.length > 0);
        }
    };

    useEffect(() => {
        if (selectionMode === "none") {
            setSelectAllLeadsState(false);
            return;
        }
        const selectable = getSelectableLeads();
        const sIds = selectable.map((lead: any) => lead.leadId);
        if (sIds.length > 0 && sIds.every((id: number) => selectedLeadsState.includes(id))) {
            setSelectAllLeadsState(true);
        } else {
            setSelectAllLeadsState(false);
        }
    }, [selectedLeadsState, leadData?.leads, selectionMode]);

    const toggleSelectLeadRow = (leadId: number) => {
        const lead = leadData.leads?.find((l: any) => l.leadId === leadId);
        if (!lead) return;
        if (selectionMode === "assign" && (lead.assignedToUserId || isLeadWon(lead))) return;
        if (selectionMode === "reassign" && isLeadWon(lead)) return;

        setSelectedLeadsState((prev) =>
            prev.includes(leadId) ? prev.filter((id) => id !== leadId) : [...prev, leadId]
        );
    };

    const handleOpenReassignModal = (row: ILead) => {
        if (isLeadWon(row)) {
            addToast({ message: "Won leads cannot be reassigned", status: "warning" });
            return;
        }
        setReassignLead(row);
        setSelectedUserId(row.assignedToUserId ?? null);
        setReassignNote("");
        setIsReassignOpen(true);
        loadTeamUsers();
    };

    const handleReassign = async () => {
        if (!reassignLead || isLeadWon(reassignLead) || !selectedUserId || reassignLoading) return;
        setReassignLoading(true);
        try {
            const payload = {
                leadId: reassignLead.leadId,
                newAssignedUserId: selectedUserId,
                note: reassignNote,
            };
            const res = await fetchApi("MyTeamLead/ReassignLead", "PUT", payload);
            if (res) {
                addToast({ message: "Lead reassigned successfully", status: "success" });
                setIsReassignOpen(false);
                setReassignLead(null);
                setSelectedUserId(null);
                setReassignNote("");
                loadLeads();
            }
        } catch (error) {
            console.error("Reassign error:", error);
        } finally {
            setReassignLoading(false);
        }
    };

    const handleMultiAssign = async () => {
        const validLeadIds = selectedLeadsState.filter((id) => {
            const lead = leadData.leads?.find((l) => l.leadId === id);
            return lead ? !isLeadWon(lead) : true;
        });
        if (!multiAssignUserId || validLeadIds.length === 0 || multiReassignLoading) return;
        setMultiReassignLoading(true);
        try {
            const payload = {
                leadIds: validLeadIds,
                newAssignedUserId: multiAssignUserId,
                remarks: multiAssignRemarks,
            };
            const res = await fetchApi("MyTeamLead/ReassignMultipleLeads", "PUT", payload);
            if (res) {
                addToast({
                    message: `${validLeadIds.length} lead${validLeadIds.length > 1 ? "s" : ""} reassigned successfully`,
                    status: "success",
                });
                setIsMultiAssignOpen(false);
                setMultiAssignUserId(null);
                setMultiAssignRemarks("");
                setSelectedLeadsState([]);
                setSelectAllLeadsState(false);
                setSelectionMode("none");
                loadLeads();
            }
        } catch (error) {
            console.error("Multi reassign error:", error);
        } finally {
            setMultiReassignLoading(false);
        }
    };

    return (

        <MyDiv>

            {/* Selection Mode Toggle Buttons */}
            <Flex mb={4} justify="space-between" align="center" wrap="wrap" gap={3} mt={4}>
                <Flex align="center" gap={2} wrap="wrap">
                    {canAssign && (
                        <Button
                            size="sm"
                            borderRadius="8px"
                            variant={selectionMode === "assign" ? "solid" : "outline"}
                            colorScheme="blue"
                            leftIcon={<AddIcon />}
                            onClick={() => {
                                if (selectionMode === "assign") {
                                    setSelectionMode("none");
                                    setSelectedLeadsState([]);
                                } else {
                                    setSelectionMode("assign");
                                    setSelectedLeadsState([]);
                                }
                            }}
                        >
                            Assign Lead {selectionMode === "assign" && selectedLeadsState.length > 0 ? `(${selectedLeadsState.length})` : ""}
                        </Button>
                    )}

                    {canReassign && (
                        <Button
                            size="sm"
                            borderRadius="8px"
                            variant={selectionMode === "reassign" ? "solid" : "outline"}
                            colorScheme="purple"
                            leftIcon={<RepeatIcon />}
                            onClick={() => {
                                if (selectionMode === "reassign") {
                                    setSelectionMode("none");
                                    setSelectedLeadsState([]);
                                } else {
                                    setSelectionMode("reassign");
                                    setSelectedLeadsState([]);
                                    loadTeamUsers();
                                }
                            }}
                        >
                            Bulk Reassign {selectionMode === "reassign" && selectedLeadsState.length > 0 ? `(${selectedLeadsState.length})` : ""}
                        </Button>
                    )}
                </Flex>

                {selectionMode !== "none" && (
                    <Button
                        size="xs"
                        variant="ghost"
                        color="gray.500"
                        onClick={() => {
                            setSelectionMode("none");
                            setSelectedLeadsState([]);
                        }}
                    >
                        Cancel Selection Mode
                    </Button>
                )}
            </Flex>

            {/* Banner when Assign Mode has selection */}
            {selectionMode === "assign" && selectedLeadsState.length > 0 && (
                <Flex mb={4} p={3} bg="blue.50" border="1px solid" borderColor="blue.100" borderRadius="12px"
                    align={{ base: "stretch", md: "center" }} justify="space-between"
                    direction={{ base: "column", md: "row" }} gap={3}
                >
                    <Flex align="center" gap={3}>
                        <Box px={3} py={1} borderRadius="full" bg="blue.100" color="blue.700" fontWeight="700" fontSize="sm">
                            {selectedLeadsState.length} selected
                        </Box>
                        <Text fontSize="sm" color="gray.700" fontWeight="500">
                            Assign selected leads to a team member
                        </Text>
                    </Flex>

                    <Flex gap={2} wrap="wrap">
                        <Button size="sm" colorScheme="blue" variant="solid"
                            onClick={() => {
                                const selectedRows = (leadData.leads || []).filter((lead: any) =>
                                    selectedLeadsState.includes(lead.leadId) && !lead.assignedToUserId && !isLeadWon(lead)
                                );
                                setSelectedLeadsData(selectedRows);
                                setIsAssignModalOpen(true);
                            }}
                        >
                            Assign Lead ({selectedLeadsState.length})
                        </Button>

                        <Button size="sm" variant="ghost"
                            onClick={() => setSelectedLeadsState([])}
                        >
                            Clear
                        </Button>
                    </Flex>
                </Flex>
            )}

            {/* Banner when Reassign Mode has selection */}
            {selectionMode === "reassign" && selectedLeadsState.length > 0 && (
                <Flex mb={4} p={3} bg="purple.50" border="1px solid" borderColor="purple.100" borderRadius="12px"
                    align={{ base: "stretch", md: "center" }} justify="space-between"
                    direction={{ base: "column", md: "row" }} gap={3}
                >
                    <Flex align="center" gap={3}>
                        <Box px={3} py={1} borderRadius="full" bg="purple.100" color="purple.700" fontWeight="700" fontSize="sm">
                            {selectedLeadsState.length} selected
                        </Box>
                        <Text fontSize="sm" color="gray.700" fontWeight="500">
                            Reassign selected leads to another team member
                        </Text>
                    </Flex>

                    <Flex gap={2} wrap="wrap">
                        <Button size="sm" colorScheme="purple" variant="solid" leftIcon={<RepeatIcon />}
                            onClick={() => {
                                loadTeamUsers();
                                setIsMultiAssignOpen(true);
                            }}
                        >
                            Reassign ({selectedLeadsState.length})
                        </Button>

                        <Button size="sm" variant="ghost"
                            onClick={() => setSelectedLeadsState([])}
                        >
                            Clear
                        </Button>
                    </Flex>
                </Flex>
            )}

            {/* TABLE */}
            <Grid className="grid_container">
                <GridItem colSpan={12}>
                    <CustomExpandTable
                        value={leadData.leads}
                        loading={loading}
                        rowKey="leadId"
                        autoCloseExpand={true}
                        headerTextColor="#1A202C"
                        emptyMessage="No Data Found"
                        getRowBgColor={(row: any) => row.isAccepted === false ? "#FFECEC" : undefined}
                        renderExpandedContent={(row: any) => (
                            <Box p={4} bg="#F7F7FF">
                                {expandType[row.leadId] === "duplicate" ? (
                                    <SimilarLeadExpand data={duplicateDetails[row.leadId] || []} RevealField={RevealField} />
                                ) : (
                                    <LeadRequirement
                                        leadId={row.leadId}
                                        leadData={row}
                                        onClose={row.closeExpand}
                                    />
                                )}
                            </Box>
                        )}
                    >
                        {/* Checkbox Column */}
                        {selectionMode !== "none" && (
                            <Column
                                header={
                                    <Checkbox
                                        isChecked={isAllSelected}
                                        isDisabled={!hasSelectable}
                                        onChange={toggleSelectAll}
                                    />
                                }
                                body={(row: any) => {
                                    const isRowDisabled =
                                        selectionMode === "assign"
                                            ? (!!row.assignedToUserId || isLeadWon(row))
                                            : isLeadWon(row);

                                    return (
                                        <Tooltip
                                            label={
                                                isLeadWon(row)
                                                    ? "Won leads cannot be reassigned"
                                                    : row.assignedToUserId && selectionMode === "assign"
                                                        ? "Already Assigned"
                                                        : ""
                                            }
                                            isDisabled={!isRowDisabled}
                                            hasArrow
                                        >
                                            <Box display="inline-block">
                                                <Checkbox
                                                    isDisabled={isRowDisabled}
                                                    cursor={isRowDisabled ? "not-allowed" : "pointer"}
                                                    isChecked={!isRowDisabled && selectedLeadsState.includes(row.leadId)}
                                                    onChange={() => {
                                                        if (isRowDisabled) return;
                                                        toggleSelectLeadRow(row.leadId);
                                                        if (selectionMode === "reassign" && userOptions.length === 0) {
                                                            loadTeamUsers();
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </Tooltip>
                                    );
                                }}
                            />
                        )}
                        <Column header="S.No" body={(_, index) => index + 1} />
                        {/* <Column header="Lead ID" field="leadId" /> */}
                        {/* COMPANY */}
                        {/* <Column header="Company" body={(row: any, index: number) => (<RevealField rowIndex={index} field="company" value={row.companyName} />)} textAlign="center" /> */}
                        <Column
                            header="Company"
                            body={(row: any, index: number) => (
                                <Tooltip label={getDisplayValue(row.companyName, "company", index)} hasArrow placement="top" >
                                    {/* <Box maxW="200px" isTruncated cursor="pointer"> */}
                                    <RevealField rowIndex={index} field="company" value={row.companyName} />
                                    {/* </Box> */}
                                </Tooltip>
                            )}
                            textAlign="center"
                        />


                        {/* POC */}
                        {/* <Column header="POC" body={(row: any, index: number) => (<RevealField rowIndex={index} field="poc" value={row.pocName} />)} textAlign="center" /> */}

                        <Column
                            header="POC"
                            body={(row: any, index: number) => (
                                <Tooltip label={getDisplayValue(row.pocName, "poc", index)} hasArrow >
                                    {/* <Box maxW="150px" isTruncated cursor="pointer"> */}
                                    <RevealField rowIndex={index} field="poc" value={row.pocName} />
                                    {/* </Box> */}
                                </Tooltip>
                            )}
                        />


                        {/* PHONE */}
                        <Column header="Phone Number" body={(row: any, index: number) => (
                            <RevealField rowIndex={index} field="contact" value={row.contact} />
                        )}
                            textAlign="center"
                        />

                        {/* EMAIL */}
                        <Column header="Email" body={(row: any, index: number) => (
                            <RevealField rowIndex={index} field="email" value={row.email} />
                        )} textAlign="center" />

                        <Column
                            header="Website"
                            body={(row: any, index: number) => {
                                const canOpenWebsite =
                                    row.isAccepted ||
                                    hasPermission("LeadPool", "View Website Before Accept");

                                return (
                                    <RevealField
                                        rowIndex={index}
                                        field="websiteUrl"
                                        value={row.websiteUrl}
                                    >
                                        {row.websiteUrl ? (
                                            canOpenWebsite ? (
                                                <Link
                                                    href={
                                                        row.websiteUrl.startsWith("http")
                                                            ? row.websiteUrl
                                                            : `https://${row.websiteUrl}`
                                                    }
                                                    isExternal
                                                    color="#2563EB"
                                                    textDecoration="underline"
                                                    maxW="180px"
                                                    display="block"
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                >
                                                    {row.websiteUrl}
                                                </Link>
                                            ) : (
                                                <Text
                                                    maxW="180px"
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                >
                                                    {row.websiteUrl}
                                                </Text>
                                            )
                                        ) : (
                                            <Text>N/A</Text>
                                        )}
                                    </RevealField>
                                );
                            }}
                        />

                        <Column header="Country" field="countryName" textAlign="center" />

                        <Column header="Assigned To" field="assignedToUser" />
                        <Column header="Source" field="sourceName" />

                        {/* <Column header="Source" field="source" /> */}
                        <Column
                            header="Status"
                            body={(row: any) => {
                                const statusStyle = getStatusStyle(row.leadStatus || "Lead Created");

                                const isFinalStatus =
                                    row.leadStatus === "Won" ||
                                    row.leadStatus === "Lost";

                                return (
                                    <Box display="inline-flex" alignItems="center" bg={statusStyle.bg} color={statusStyle.color} px="12px" py="6px" borderRadius="20px" fontSize="13px" fontWeight="500" gap="6px" width="fit-content" cursor={isFinalStatus ? "not-allowed" : "pointer"} opacity={isFinalStatus ? 0.7 : 1}
                                        onClick={() => { if (!isFinalStatus) { handleOpenStatusModal(row); } }}
                                    >
                                        <Text m={0} className="font-poppins text_medium text_sm">
                                            {row.leadStatus || "Lead Created"}
                                        </Text>

                                        {!isFinalStatus && (
                                            <Image src={ArrowIcon} boxSize="6px" />
                                        )}
                                    </Box>
                                );
                            }}
                        />
                        {/* <Column
                            header="Sales Stage"
                            body={(row: any) => {
                                const statusStyle = getStatusStyle(row.status);
                                return (
                                    <Box display="inline-flex" alignItems="center" bg={statusStyle.bg} color={statusStyle.color} px="12px" py="6px" borderRadius="20px" fontSize="13px" fontWeight="500" gap="6px" width="fit-content" >
                                        <Text m={0} className="font-poppins text_medium text_sm">{row.saleStage}</Text>
                                    </Box>
                                );
                            }}
                        /> */}
                        <Column header="Created By" field="createdBy" />

                        {/* ASSIGNED DATE */}
                        <Column header="Created At" body={(row: any) => showDateTime(row.createdAt)} />


                        {/* ACTION */}
                        <Column
                            header="Action"
                            body={(row: any) => {

                                const isPending = row.isAccepted === null;
                                const isAccepted = row.isAccepted === true;
                                const isRejected = row.isAccepted === false;
                                return (
                                    <Flex align="center" gap={2} wrap="nowrap" width="max-content" >

                                        {isAccepted && (
                                            <Tooltip label={`Accepted: ${row.reason ? ` ${row.reason}` : ""}`} hasArrow>
                                                <Flex
                                                    w="24px"
                                                    h="24px"
                                                    borderRadius="full"
                                                    bg="green.500"
                                                    color="white"
                                                    align="center"
                                                    justify="center"
                                                    cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                    _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                    onClick={() => {
                                                        if (canViewLeadAcceptanceHistory) {
                                                            NavigateLeadAssesment(row); // Calls API / opens Lead Acceptance History
                                                        }
                                                    }}
                                                >
                                                    <CheckIcon boxSize={3} />
                                                </Flex>
                                            </Tooltip>
                                        )}

                                        {isRejected && (
                                            <>
                                                <Tooltip label={`Rejected${(row.disReason || row.disqualifyReason) ? ` [${row.disReason || row.disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                                                    <Flex
                                                        w="24px"
                                                        h="24px"
                                                        borderRadius="full"
                                                        bg="red.500"
                                                        color="white"
                                                        align="center"
                                                        justify="center"
                                                        cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                        _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                        onClick={() => {
                                                            if (canViewLeadAcceptanceHistory) {
                                                                NavigateLeadAssesment(row); // Calls API / opens Lead Acceptance History
                                                            }
                                                        }}
                                                    >
                                                        <SmallCloseIcon boxSize={2.5} />
                                                    </Flex>
                                                </Tooltip>
                                                {(row.disReason || row.disqualifyReason) && (
                                                    <Tooltip label={`Disqualify Reason: ${row.disReason || row.disqualifyReason}`} hasArrow>
                                                        <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                                                            color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                                                            fontWeight="500" maxW="140px"
                                                        >
                                                            <Text isTruncated>{row.disReason || row.disqualifyReason}</Text>
                                                        </Flex>
                                                    </Tooltip>
                                                )}
                                            </>
                                        )}

                                        {isPending && (
                                            <Tooltip label="Pending Acceptance" hasArrow>
                                                <Flex
                                                    w="24px"
                                                    h="24px"
                                                    borderRadius="full"
                                                    bg="orange.400"
                                                    color="white"
                                                    align="center"
                                                    justify="center"
                                                >
                                                    <TimeIcon boxSize={3} />
                                                </Flex>
                                            </Tooltip>
                                        )}



                                        {canViewHistory && (<Tooltip label="History" placement="bottom" hasArrow>
                                            <Image
                                                src={HistoryIcon}
                                                cursor="pointer"
                                                boxSize="18px"
                                                onClick={() => handleHistoryLead(row)}
                                            />
                                        </Tooltip>)}

                                        {canSelfAssign && (<Tooltip
                                            label={
                                                row.assignedToUserId
                                                    ? "Already Assigned"
                                                    : "Self Assign"
                                            }
                                            placement="bottom"
                                            hasArrow
                                        >
                                            <Image
                                                src={SelfAssignIcon}
                                                boxSize="18px"
                                                cursor={
                                                    row.assignedToUserId
                                                        ? "not-allowed"
                                                        : "pointer"
                                                }
                                                opacity={row.assignedToUserId ? 0.5 : 1}
                                                onClick={() =>
                                                    !row.assignedToUserId &&
                                                    handleSelfAssign(row.leadId)
                                                }
                                            />
                                        </Tooltip>)}

                                        {canReassign && (
                                            <Tooltip
                                                label={isLeadWon(row) ? "Won leads cannot be reassigned" : "Reassign Lead"}
                                                placement="bottom"
                                                hasArrow
                                            >
                                                <Button
                                                    size="xs"
                                                    colorScheme="twitter"
                                                    variant="ghost"
                                                    p={1}
                                                    minW="28px"
                                                    h="28px"
                                                    isDisabled={isLeadWon(row)}
                                                    cursor={isLeadWon(row) ? "not-allowed" : "pointer"}
                                                    onClick={() => {
                                                        if (!isLeadWon(row)) {
                                                            handleOpenReassignModal(row);
                                                        }
                                                    }}
                                                >
                                                    <span style={{ fontSize: "10px", lineHeight: 1 }}>👤⇋👤</span>
                                                </Button>
                                            </Tooltip>
                                        )}

                                        {hasPermission('LeadPool', 'Requirement Gathering') && row.leadStatus === "Requirement Gathering" && (
                                            <Tooltip label="Requirement Gathering" placement="bottom" hasArrow>
                                                <Image
                                                    src={UserIcon}
                                                    cursor="pointer"
                                                    boxSize="18px"
                                                    onClick={row.toggleExpand}
                                                />
                                            </Tooltip>
                                        )}
                                        {hasPermission('LeadPool', 'View Duplicates') && (row.duplicateCount ?? 0) > 0 && (
                                            <Tooltip label="Similar Lead" placement="bottom" hasArrow >
                                                <Flex align="center" gap={1} bg="red.50" borderColor="red.200" borderRadius="md" px={2} py={1} cursor="pointer" onClick={() => handleDuplicateClick(row)} >
                                                    <Image src={DuplicateIcon} boxSize="16px" alt="Duplicate" />
                                                    <Text fontSize="sm" fontWeight="500" color="red.600">
                                                        {row.duplicateCount}
                                                    </Text>
                                                </Flex>
                                            </Tooltip>
                                        )}

                                        {/* {canEdit && (
  <Tooltip label="Edit Lead" placement="bottom" hasArrow>
    <Image
      src={EditIcon}
      cursor="pointer"
      boxSize="18px"
      onClick={() => NavigateMyLeadEdit(row)}
    />
  </Tooltip>
)} */}
                                    </Flex>
                                )
                            }}
                        />
                    </CustomExpandTable>
                </GridItem>
            </Grid>
            <Modal isOpen={isStatusOpen} onClose={handleCloseStatusModal} isCentered>
                <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                <ModalContent borderRadius="12px" maxW="380px">
                    <ModalHeader>Update Status</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <Box mb={4}>
                            <Text className="font-poppins text_medium text_md" mb={1}>
                                Select Status
                            </Text>

                            <Select
                                value={selectedStatus?.id || ""}
                                placeholder="Select status"
                                borderRadius="8px"
                                fontSize="13px"
                                onChange={(e) => {
                                    const selected = statusOptions.find(
                                        (s) => s.id === Number(e.target.value)
                                    );

                                    setSelectedStatus(selected || null);
                                    setSelectedStatusReason(null);
                                }}
                            >
                                {statusOptions.map((status) => (
                                    <option key={status.id} value={status.id}>
                                        {status.label}
                                    </option>
                                ))}
                            </Select>
                        </Box>

                        {/* Status Reason */}
                        {statusReasonOptions.length > 0 && (
                            <Box mb={4}>
                                <Text className="font-poppins text_medium text_md" mb={1}>
                                    Status Reason <Text as="span" color="red.500">*</Text>
                                </Text>

                                <Select
                                    value={selectedStatusReason?.id || ""}
                                    placeholder="Select status reason"
                                    borderRadius="8px"
                                    fontSize="13px"
                                    onChange={(e) => {
                                        const selected = statusReasonOptions.find(
                                            (s) => s.id === Number(e.target.value)
                                        );
                                        setSelectedStatusReason(selected || null);
                                    }}
                                >
                                    {statusReasonOptions.map((reason) => (
                                        <option key={reason.id} value={reason.id}>
                                            {reason.label}
                                        </option>
                                    ))}
                                </Select>
                            </Box>
                        )}
                        <Box mb={2}>
                            <Text className="font-poppins text_medium text_md" mb={1}>
                                Description
                            </Text>

                            <Textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter description..."
                                borderRadius="8px"
                                fontSize="13px"
                            />
                        </Box>
                    </ModalBody>

                    <ModalFooter gap={3}>
                        <Button variant="ghost" onClick={handleCloseStatusModal}>
                            Cancel
                        </Button>

                        <Button bg="#4048D6" _hover={{ bg: "#353CC4" }} color="white" onClick={handleUpdateStatus} isDisabled={!selectedStatus || looading || (statusReasonOptions.length > 0 && !selectedStatusReason)}>
                            Update
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Single Reassign Modal */}
            <Modal
                isOpen={isReassignOpen}
                onClose={() => { if (!reassignLoading) { setIsReassignOpen(false); setReassignNote(""); } }}
                closeOnOverlayClick={!reassignLoading}
                isCentered
            >
                <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                <ModalContent borderRadius="12px" maxW="380px">
                    <ModalHeader fontSize="16px">Reassign Lead</ModalHeader>
                    <ModalCloseButton isDisabled={reassignLoading} />

                    <ModalBody>
                        <Box mb={4} p={3} bg="#F9FAFB" borderRadius="8px" border="1px solid #E4E7EC">
                            <Text fontSize="12px" color="#667085" mb={1}>
                                Company
                            </Text>
                            <Text fontSize="14px" fontWeight="600" color="#101828" mb={2}>
                                {reassignLead?.companyName || "N/A"}
                            </Text>
                            <Text fontSize="12px" color="#667085" mb={1}>
                                Current Assignee
                            </Text>
                            <Text fontSize="13px" fontWeight="500" color="#344054">
                                {reassignLead?.assignedToUser || "Unassigned"}
                            </Text>
                        </Box>

                        <Box mb={4}>
                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                Assign To
                            </Text>
                            <Select
                                value={selectedUserId ?? ""}
                                placeholder="Select team member"
                                borderRadius="8px"
                                fontSize="13px"
                                onChange={(e) => setSelectedUserId(Number(e.target.value))}
                            >
                                {userOptions.map((user) => (
                                    <option key={user.id} value={user.id}>
                                        {user.name}
                                    </option>
                                ))}
                            </Select>
                        </Box>

                        <Box mb={2}>
                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                Description / Note
                            </Text>
                            <Textarea
                                value={reassignNote}
                                onChange={(e) => setReassignNote(e.target.value)}
                                placeholder="Enter note..."
                                borderRadius="8px"
                                fontSize="13px"
                                rows={3}
                            />
                        </Box>
                    </ModalBody>

                    <ModalFooter gap={3}>
                        <Button
                            variant="ghost"
                            onClick={() => { setIsReassignOpen(false); setReassignNote(""); }}
                            isDisabled={reassignLoading}
                        >
                            Cancel
                        </Button>

                        <Button
                            colorScheme="purple"
                            onClick={handleReassign}
                            isLoading={reassignLoading}
                            loadingText="Reassigning..."
                            isDisabled={!selectedUserId || reassignLoading}
                        >
                            Reassign
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Multi Assign / Reassign Modal */}
            <Modal
                isOpen={isMultiAssignOpen}
                onClose={() => { if (!multiReassignLoading) { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); } }}
                closeOnOverlayClick={!multiReassignLoading}
                isCentered
            >
                <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                <ModalContent borderRadius="12px" maxW="380px">
                    <ModalHeader fontSize="16px">Reassign Leads</ModalHeader>
                    <ModalCloseButton isDisabled={multiReassignLoading} />

                    <ModalBody>
                        <Box mb={4} p={3} bg="#F9FAFB" borderRadius="8px" border="1px solid #E4E7EC">
                            <Text fontSize="12px" color="#667085" mb={1}>
                                Selected Leads
                            </Text>
                            <Text fontSize="13px" fontWeight="600" color="#344054">
                                {selectedLeadsState.length} Lead{selectedLeadsState.length > 1 ? "s" : ""} will be reassigned
                            </Text>
                        </Box>

                        <Box mb={4}>
                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                Assign To
                            </Text>
                            <Select
                                value={multiAssignUserId ?? ""}
                                placeholder="Select team member"
                                borderRadius="8px"
                                fontSize="13px"
                                onChange={(e) => setMultiAssignUserId(Number(e.target.value))}
                            >
                                {userOptions.map((user) => (
                                    <option key={user.id} value={user.id}>
                                        {user.name}
                                    </option>
                                ))}
                            </Select>
                        </Box>

                        <Box mb={2}>
                            <Text fontSize="14px" fontWeight="500" mb={2}>
                                Description / Remarks
                            </Text>
                            <Textarea
                                value={multiAssignRemarks}
                                onChange={(e) => setMultiAssignRemarks(e.target.value)}
                                placeholder="Enter description or remarks..."
                                borderRadius="8px"
                                fontSize="13px"
                                rows={3}
                            />
                        </Box>
                    </ModalBody>

                    <ModalFooter gap={3}>
                        <Button
                            variant="ghost"
                            onClick={() => { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); }}
                            isDisabled={multiReassignLoading}
                        >
                            Cancel
                        </Button>

                        <Button
                            colorScheme="purple"
                            onClick={handleMultiAssign}
                            isLoading={multiReassignLoading}
                            loadingText="Reassigning..."
                            isDisabled={!multiAssignUserId || selectedLeadsState.length === 0 || multiReassignLoading}
                        >
                            Reassign
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </MyDiv>
    );
};

export default LeadPoolList;